import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authApi } from "@/lib/nexus";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const data = await authApi.session(sessionId);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-nexus-bg text-nexus-cyan font-mono text-xs tracking-[0.3em] uppercase gap-2"
    >
      <Loader2 className="animate-spin" size={16} /> Authenticating…
    </div>
  );
}
